import type { GetIssueAssessmentByParentIdResponse } from '@risksmart-app/drizzle/src/dto';
import type { GetIssueAssessmentByParentIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetIssueAssessmentByParentIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createLazyQueryHook } from 'src/utils';

type UseLazyGetIssueAssessmentsByParentIdArgs = {
  parentIssueId: string;
};

export const useLazyGetIssueAssessmentsByParentId = createLazyQueryHook<
  UseLazyGetIssueAssessmentsByParentIdArgs,
  GetIssueAssessmentByParentIdResponse,
  GetIssueAssessmentByParentIdQuery
>({
  trpcQuery: (client, { parentIssueId }) =>
    client.frontend.issue.issueAssessmentByParentId.query({
      parentIssueId,
    }),
  mapTrpcDataToGraphQL: (data) => data,
  graphqlDocument: GetIssueAssessmentByParentIdDocument,
  graphqlVariables: ({ parentIssueId }) => ({ parentIssueId }),
});
